<div>
    <div id="board"></div>
</div>
